export default "/_next/static/images/082759554bee135efcd83bf52f7ffced.png";